{
  "common": {
    "loading": "読み込み中…",
    "cancel": "キャンセル",
    "close": "閉じる"
  },
  "themes": {
    "title": "ネットショップのデザイン",
    "intro": "ネットショップの見た目を変更します。変更はまず下書きとして保存され、公開するまでお客様には表示されません。",
    "status_live": "サイトで使用中",
    "status_draft": "下書き",
    "updated": "最終変更 {{when}}",
    "edit": "編集",
    "duplicate": "コピーを作る",
    "make_live": "サイトで使う",
    "make_live_title": "「{{name}}」をサイトに表示しますか？",
    "make_live_body": "数秒でお客様にこのデザインが表示されます。今のデザインは残るので、いつでも戻せます。",
    "copy_name": "{{name}} のコピー",
    "copied": "コピー「{{name}}」を下書きとして作成しました。",
    "published": "サイトがこのデザインになりました。",
    "action_failed": "うまくいきませんでした。もう一度お試しください。",
    "load_failed": "デザインを読み込めませんでした。もう一度お試しください。",
    "empty": "デザインはまだありません。"
  },
  "pages": {
    "index": "トップページ",
    "product": "商品ページ",
    "collection": "カテゴリーページ",
    "list_collections": "カテゴリー一覧",
    "search": "検索結果",
    "page": "お知らせページ",
    "policy": "規約のページ",
    "cart": "カート",
    "checkout": "ご注文手続き",
    "tracking": "注文状況の確認",
    "404": "ページが見つかりません",
    "password": "準備中ページ",
    "with_suffix": "{{page}} — {{suffix}}"
  },
  "toolbar": {
    "label": "編集ツール",
    "back": "戻る",
    "page": "編集するページ",
    "device": "プレビューの大きさ",
    "device_mobile": "スマホ（{{width}} px）",
    "device_tablet": "タブレット（{{width}} px）",
    "device_desktop": "パソコン（{{width}} px）",
    "preview_language": "プレビューの言語",
    "undo": "元に戻す",
    "redo": "やり直す",
    "save_draft": "下書き保存",
    "publish": "公開する",
    "publishing": "公開中…",
    "publish_not_allowed": "公開できるのはオーナーまたは店長だけです。",
    "sample_product": "見本の商品",
    "sample_collection": "見本のカテゴリー",
    "sample_none": "選ぶ…",
    "search_product": "商品を探す",
    "search_collection": "カテゴリーを探す",
    "sample_error": "今は検索できません。",
    "sample_empty": "見つかりませんでした。",
    "sample_count_other": "{{count}} 点",
    "history": "履歴",
    "request_publish": "マネージャーに公開を依頼",
    "theme_settings": "サイト全体"
  },
  "save": {
    "idle": "変更なし",
    "pending": "まだ保存されていない変更があります",
    "saving": "保存中…",
    "saved": "保存しました",
    "failed": "保存できませんでした",
    "invalid": "保存されていません — 印のついた所を直してください",
    "conflict": "他の人がこのページを変更しました",
    "retry": "もう一度"
  },
  "tree": {
    "label": "ページの部品",
    "area": {
      "header": "サイトの上部",
      "template": "ページの内容",
      "footer": "サイトの下部",
      "overlay": "ポップアップ"
    },
    "group": {
      "announcement": "お知らせバー",
      "header": "ロゴとメニュー",
      "footer": "サイトの下部",
      "overlay": "ポップアップ"
    },
    "empty": "まだ何もありません。",
    "add_section": "部品を追加",
    "add_section_to": "{{group}}に部品を追加",
    "actions_for": "{{name}}の操作",
    "move_up": "{{name}}を上へ",
    "move_down": "{{name}}を下へ",
    "cannot_move_up": "いちばん上です",
    "cannot_move_down": "いちばん下です",
    "show": "{{name}}を表示する",
    "hide": "{{name}}を隠す",
    "duplicate": "{{name}}をコピー",
    "delete": "{{name}}を削除",
    "drag": "ドラッグして{{name}}を移動",
    "expand": "{{name}}の中身を表示",
    "collapse": "{{name}}の中身を閉じる",
    "hidden": "非表示",
    "issue_count_other": "問題 {{count}} 件",
    "unknown_section": "不明な部品（{{type}}）",
    "unknown_block": "不明なパーツ（{{type}}）",
    "blocks_of": "{{name}}のパーツ",
    "add_block": "パーツを追加",
    "required": "このページに必要",
    "required_raw": "未鑑定カードに必要",
    "required_confirm_title": "「{{name}}」を削除しますか？",
    "required_confirm_raw": "未鑑定カードには必ずランク（A〜D）を表示する必要があります。このパーツがないと商品ページを公開できません。",
    "required_confirm_body": "このページにはこのパーツが必要です。ないとページを公開できません。",
    "hide_anyway": "それでも隠す",
    "delete_anyway": "それでも削除"
  },
  "reasons": {
    "unknown_type": "この部品は使えません。",
    "lives_in_header": "この部品はすでにサイトの上部にあります。",
    "lives_in_footer": "この部品はすでにサイトの下部にあります。",
    "lives_in_overlay": "この部品はポップアップ用です。",
    "other_pages_only": "この部品は別のページでしか使えません。",
    "not_in_layout_area": "この部品はサイトの上部・下部には置けません。",
    "not_on_this_page": "この部品はこのページでは使えません。",
    "max_reached_other": "このページに置けるのは {{limit}} 個までです。",
    "fixed": "この部品はページそのものなので、隠したり削除したりできません。",
    "limit_reached_other": "このパーツは {{limit}} 個までです。",
    "max_blocks": "この部品はいっぱいです（パーツは {{limit}} 個まで）。",
    "no_manifest": "部品の一覧がまだありません。"
  },
  "named_blocks": {
    "rank_indicator": "カードの状態ランク A〜D を表示します（A 美品・B 軽い傷・C 傷あり・D ダメージ）。",
    "grade_badge": "鑑定品の鑑定会社・グレード・証明書番号を表示します。",
    "condition_popup": "ランク基準の説明を開くリンクです。",
    "card_details": "カード番号・弾・レアリティ・言語を表示します。",
    "trust_notes": "お支払い・発送・本物保証などの安心メッセージです。"
  },
  "add": {
    "title": "部品を追加",
    "intro": "このページに追加するものを選んでください。",
    "intro_group": "{{group}}に追加するものを選んでください。",
    "search": "部品を検索",
    "categories": "部品の種類",
    "category": {
      "all": "すべて",
      "banner": "バナー",
      "product": "商品",
      "text": "文章",
      "media": "画像・動画",
      "other": "その他"
    },
    "results": "追加できる部品",
    "no_results": "一致する部品がありません。"
  },
  "settings": {
    "title": "設定",
    "pick_something": "左の一覧かプレビューで部品をクリックすると変更できます。",
    "problems": "直すところ",
    "hide_block": "このパーツを隠す",
    "hide_section": "この部品を隠す",
    "no_settings": "この部品には設定がありません。"
  },
  "fields": {
    "choose": "— 選択 —",
    "pick_color": "{{name}}の色を選ぶ",
    "language": "言語",
    "missing_translation": "まだ翻訳されていません",
    "change": "変更",
    "changed_from_default": "初期値から変更",
    "contrast_low": "この背景では読みにくい（{{ratio}}:1 — 4.5:1 以上が目安）",
    "contrast_ok": "この背景で読みやすい（{{ratio}}:1）",
    "css_applied": "サイトに適用される内容（このパーツのみ）：",
    "css_summary": "スタイルコード（上級）",
    "default_option": "初期値（{{value}}）",
    "edit_schemes": "カラーセットを編集",
    "exact_value": "{{name}} の値",
    "font_samples": "フォントの見本",
    "font_unavailable": "{{font}}（使用できなくなりました）",
    "help": "{{name}} の説明",
    "html_preview": "お客様に表示される内容",
    "html_removed": "使用できないため削除：{{what}}",
    "icon_none": "なし",
    "json_broken": "まだ正しくありません — 最後の正しい値を保持します。",
    "json_summary": "詳細な値（JSON）",
    "list_empty": "まだ選択されていません。",
    "list_full": "最大 {{max}} 件まで選べます。",
    "media_chosen": "ファイル選択済み",
    "media_placeholder": "見本画像（お店の画像に差し替えてください）",
    "media_none_image": "画像がありません",
    "media_none_video": "動画がありません",
    "media_none_file": "ファイルがありません",
    "media_pick_image": "画像を選ぶ",
    "media_pick_video": "動画を選ぶ",
    "media_pick_file": "ファイルを選ぶ",
    "media_change_image": "画像を変更",
    "media_change_video": "動画を変更",
    "media_change_file": "ファイルを変更",
    "off": "オフ",
    "on": "オン",
    "ref_hint": "{{kind}} のリンクを入力",
    "remove": "外す",
    "remove_item": "{{name}} を外す",
    "required": "必須",
    "scheme_missing": "カラーセット「{{id}}」はもうありません — 別のものを選んでください。",
    "scheme_name": "カラーセット {{n}}",
    "unknown_type": "新しい設定（{{type}}）です — 値を慎重に入力してください。",
    "video_url_hint": "YouTube または Vimeo のアドレスを貼り付けてください。",
    "pick": {
      "collection": "カテゴリを選ぶ",
      "product": "商品を選ぶ",
      "page": "ページを選ぶ",
      "policy": "規約ページを選ぶ",
      "menu": "メニューを選ぶ",
      "attribute": "商品情報を選ぶ"
    },
    "add": {
      "collection": "カテゴリを追加",
      "product": "商品を追加"
    },
    "align": {
      "left": "左寄せ",
      "center": "中央",
      "right": "右寄せ"
    },
    "media_alt_missing": "この画像にはまだ説明がありません（保存はできます）。",
    "media_alt_add": "説明を追加",
    "media_alt_missing_other_other": "{{count}} 言語で説明が未入力です。"
  },
  "preview": {
    "label": "プレビュー",
    "frame_title": "サイトのプレビュー（下書き）",
    "loading": "プレビューを読み込み中…",
    "token_failed": "プレビューを開けませんでした",
    "timeout": "プレビューが表示されません",
    "timeout_hint": "変更は下書きとして保存されているので大丈夫です。もう一度試すか、新しいタブで開いてください。",
    "retry": "もう一度",
    "open_tab": "新しいタブで開く"
  },
  "editor": {
    "load_failed": "エディターを開けませんでした。もう一度お試しください。",
    "no_manifest_title": "サイトの部品がまだ準備できていません",
    "no_manifest_body": "サイトからまだ部品の一覧が届いていません。サイトの準備ができると自動で届きます。しばらくしてからもう一度お試しください。",
    "part_load_failed": "「{{what}}」を読み込めませんでした。"
  },
  "publish": {
    "confirm_title": "変更を公開しますか？",
    "confirm_body": "数秒でお客様に新しいデザインが表示されます。前のバージョンにはいつでも戻せます。",
    "done": "公開しました（バージョン {{version}}）。数秒でサイトが更新されます。",
    "failed": "公開できませんでした。印のついた問題を確認して、もう一度お試しください。",
    "unsaved": "保存されていない変更があります。先に直してから公開してください。"
  },
  "leave": {
    "title": "エディターを閉じますか？",
    "body": "まだ保存されていない変更があります。",
    "save_and_leave": "保存して閉じる",
    "stay": "このまま続ける",
    "switch_title": "別のページを開きますか？",
    "switch_body": "まだ保存されていない変更があります。保存して「{{page}}」を開きますか？",
    "save_and_switch": "保存して開く"
  },
  "conflict": {
    "title": "他の人が編集しています",
    "body": "「{{what}}」は、あなたが開いた後に他の人が変更しました。相手の内容を読み込みますか（あなたの最後の変更は消えます）、それとも自分の内容で上書きしますか（相手の変更が置き換わります）？",
    "reload": "相手の内容を読み込む",
    "overwrite": "自分の内容で上書き"
  },
  "toast": {
    "section_removed": "「{{name}}」を削除しました。",
    "block_removed": "「{{name}}」を削除しました。",
    "undo": "元に戻す"
  },
  "narrow": {
    "title": "パソコンか横向きのタブレットで開いてください",
    "body": "デザインの編集には広い画面が必要です。ページ・メニュー・お知らせはこのスマホでも変更できます。",
    "content": "ページとメニューを編集",
    "back": "デザイン一覧に戻る"
  },
  "issues": {
    "generic": "ここに確認が必要なところがあります。",
    "required_missing": "必須：{{setting}} が空です。",
    "media_missing": "画像がありません — 画像を選んでください。",
    "media_unverified": "画像をまだ確認できていません。",
    "unknown_section_type": "サイトにこの部品がなくなりました。",
    "unknown_block_type": "サイトにこのパーツがなくなりました。",
    "section_not_allowed_here": "この部品はここでは使えません。",
    "too_many_sections_of_type": "この部品がページに多すぎます。",
    "too_many_sections": "ページの部品が多すぎます。",
    "too_many_blocks": "この部品のパーツが多すぎます。",
    "block_limit_exceeded": "このパーツが多すぎます。",
    "required_block_missing": "必要なパーツがありません（例：商品ページのランク表示）。",
    "invalid_value": "{{setting}} に使えない値が入っています。",
    "invalid_ref": "{{setting}} のリンク先が正しくありません。",
    "invalid_ref_kind": "{{setting}} のリンク先の種類が違います。",
    "ref_not_found": "{{setting}} のリンク先が見つかりません。",
    "ref_not_published": "{{setting}} のリンク先がまだ公開されていません。",
    "unsafe_html": "文章に使えないコードが含まれています。",
    "html_cleaned": "サイトが対応していない書式を取り除きました。",
    "unsafe_css": "スタイルのコードに使えないものが含まれています。",
    "unknown_setting": "古い設定（{{setting}}）は使われていません。",
    "unknown_locale": "ショップで使っていない言語の文章があります。",
    "low_contrast": "文字と背景の色が見えにくい組み合わせです。",
    "font_not_allowed": "このフォントは使えません。",
    "unknown_color_scheme": "この配色は存在しません。",
    "section_not_in_order": "保存されているのにページに表示されない部品があります。",
    "manifest_missing": "サイトの部品の一覧がまだありません。",
    "color_required": "カラーセットに色が足りません。",
    "invalid_color": "色の書き方が正しくありません（#RRGGBB）。",
    "duplicate_color_scheme_id": "同じ名前のカラーセットがあります。",
    "color_schemes_required": "カラーセットが最低1つ必要です。",
    "liquid_syntax": "テキスト内の商品データのコードが正しくありません。",
    "liquid_forbidden_tag": "テキストに使えないコードがあります。",
    "template_missing": "デザインがないページの種類があります — そのページは「見つかりません」と表示されます。"
  },
  "picker": {
    "description": "検索して、使いたいものをクリックしてください。",
    "empty": "見つかりません。",
    "failed": "今は検索できません。もう一度お試しください。",
    "results": "検索結果",
    "search": "検索",
    "products_count_one": "{{count}} 商品",
    "products_count_other": "{{count}} 商品",
    "links_count_one": "{{count}} リンク",
    "links_count_other": "{{count}} リンク",
    "status": {
      "active": "販売中",
      "draft": "非公開",
      "archived": "アーカイブ",
      "sold_out": "売り切れ",
      "published": "公開中",
      "scheduled": "予約済み",
      "trashed": "ゴミ箱",
      "ready": "使用可能",
      "processing": "処理中"
    }
  },
  "link": {
    "goes_to": "リンク先",
    "filter_advanced": "絞り込み（上級）",
    "only_rank": "ランクで絞り込み",
    "rank": "ランク {{rank}}",
    "search_placeholder": "検索する言葉（例：pikachu）",
    "target": {
      "collection": "カテゴリ",
      "product": "商品",
      "page": "お知らせページ",
      "policy": "規約ページ",
      "search": "検索結果",
      "url": "その他のアドレス",
      "filtered": "絞り込んだカテゴリ"
    }
  },
  "liquid": {
    "insert_button": "商品データを挿入",
    "insert": {
      "product_title": "商品名",
      "product_price": "価格",
      "product_rank": "ランク（A–D）",
      "product_grade": "グレード（鑑定品）",
      "product_set": "セット名",
      "product_number": "カード番号",
      "collection_title": "カテゴリ名",
      "shop_name": "ショップ名"
    }
  },
  "translate": {
    "auto": "自動翻訳",
    "copy_all_from_en": "空欄すべてに英語をコピー",
    "copy_from_en": "英語からコピー",
    "copied_mark": "コピーしました — 確認してください",
    "machine_mark": "機械翻訳 — 確認してください",
    "editing_language": "編集中：{{language}}",
    "failed": "翻訳できませんでした。もう一度試すか、直接入力してください。",
    "not_enabled": "自動翻訳はまだ有効になっていません。直接入力するか、英語からコピーしてください。",
    "working": "翻訳中…"
  },
  "richtext": {
    "bold": "太字",
    "bullets": "箇条書き",
    "italic": "斜体",
    "link": "リンクを追加",
    "link_address": "リンク先アドレス",
    "link_apply": "リンクを追加",
    "numbers": "番号付きリスト",
    "toolbar": "{{name}} の文字スタイル",
    "unlink": "リンクを外す"
  },
  "validation": {
    "invalid": "この値は使えません。",
    "required": "入力してください。",
    "maxLength": "長すぎます — {{limit}} 文字以内。",
    "minLength": "短すぎます — {{limit}} 文字以上。",
    "maximum": "{{limit}} 以下にしてください。",
    "minimum": "{{limit}} 以上にしてください。",
    "exclusiveMaximum": "{{limit}} 未満にしてください。",
    "exclusiveMinimum": "{{limit}} より大きくしてください。",
    "maxItems": "{{limit}} 件以内にしてください。",
    "minItems": "{{limit}} 件以上にしてください。",
    "multipleOf": "{{limit}} の倍数にしてください。",
    "enum": "選択肢から選んでください。",
    "type": "ここではこの種類の値は使えません。",
    "pattern": "形式が正しくありません。",
    "uniqueItems": "同じものが二回選ばれています。",
    "bad_link": "このリンクは正しくありません。",
    "wrong_kind": "リンク先の種類が違います（{{kind}}）。",
    "liquid_syntax": "商品データのコードが正しくありません（{{detail}}）。",
    "liquid_forbidden_tag": "「{{detail}}」はここでは使えません。",
    "liquid_unknown_variable": "不明な商品データ：{{detail}}",
    "liquid_unknown_filter": "不明な書式：{{detail}}",
    "css_backslash": "スタイルコードにバックスラッシュは使えません。",
    "css_style_tag": "「</style」は使えません。",
    "css_script_url": "javascript: リンクは使えません。",
    "css_expression": "expression() は使えません。",
    "css_comment_open": "コメント /* … */ が閉じていません。",
    "css_quote_open": "引用符が閉じていません。",
    "css_outside_url": "画像やリンクはこのショップ内（/ で始まるアドレス）のみ使えます。",
    "css_at_rule": "{{detail}} はスタイルコードで使えません。",
    "css_attr_in_url": "url() の中で attr() は使えません。",
    "css_url_open": "url( が閉じていません。",
    "css_url_malformed": "url() の書き方が正しくありません。",
    "css_forbidden": "{{detail}} は使えません。"
  },
  "schemes": {
    "add": "カラーセットを追加",
    "contrast_button": "ボタンの文字",
    "contrast_text": "背景上の文字",
    "duplicate": "{{name}} を複製",
    "in_use_one": "{{count}} か所で使用中",
    "in_use_other": "{{count}} か所で使用中",
    "last_one": "サイトにはカラーセットが最低1つ必要です。",
    "list": "カラーセット",
    "ratio_low": "{{ratio}}:1 — 読みにくい",
    "ratio_ok": "{{ratio}}:1 — 読みやすい",
    "remove": "{{name}} を削除",
    "sample_button": "カートに入れる",
    "sample_heading": "ピカチュウ ex — ランクA",
    "sample_secondary": "サブ背景",
    "sample_text": "日本から2〜3日で発送します。",
    "show_uses": "（表示）",
    "role": {
      "background": "背景",
      "text": "文字",
      "accent": "ボタン",
      "accent_contrast": "ボタンの文字",
      "secondary": "サブ背景"
    }
  },
  "theme_settings": {
    "title": "サイト全体",
    "group": {
      "localization": "言語"
    },
    "localization_body": "サイトで表示する言語と、お客様を各言語のページへ案内する方法は「言語」画面で設定します。通貨と国は「マーケット」画面にあります。",
    "migrate": "設定を更新",
    "migrate_failed": "更新できませんでした。もう一度お試しください。",
    "migrating": "更新中…",
    "migration_body": "サイトに新しい設定が追加されました。更新すると表示されます — 今の設定はそのまま残ります。",
    "migration_title": "新しい設定があります",
    "open_localization": "言語を開く",
    "open_markets": "マーケットを開く",
    "markets_not_ready": "「マーケット」画面（通貨と国）はまだ準備中です。マーケット機能の追加時に使えるようになります。",
    "recommended_size": "推奨サイズ：{{size}} px",
    "reset": "初期値に戻す",
    "reset_body": "このグループの設定がすべて初期値に戻ります。元に戻すこともできます。",
    "reset_title": "「{{group}}」を初期値に戻しますか？"
  },
  "typography": {
    "preview": "文字の見え方"
  },
  "diff": {
    "added": "追加：{{names}}",
    "headline_one": "{{count}} 件の変更：",
    "headline_other": "{{count}} 件の変更：",
    "nothing": "サイトと比べて変更はありません。",
    "page_added": "新しいページ",
    "page_removed": "ページ削除",
    "removed": "削除：{{names}}",
    "reordered": "並び順の変更",
    "whole_website": "サイト全体",
    "marker": {
      "type": "パーツの種類",
      "disabled": "表示／非表示",
      "blocks": "パーツ",
      "block_order": "パーツの順番"
    }
  },
  "publish_dialog": {
    "blocked_now": "先に直す必要があるものがあります — 一覧を見てください。",
    "check_failed": "チェックできませんでした。もう一度お試しください。",
    "checking": "変更を保存してチェックしています…",
    "errors_one": "公開前に {{count}} 件直す必要があります",
    "errors_other": "公開前に {{count}} 件直す必要があります",
    "fix": "直す",
    "later": "日時を指定",
    "note": "メモ（任意）",
    "note_placeholder": "例：秋のバナー",
    "now": "今すぐ",
    "policy_missing": "特定商取引法に基づく表記がまだ完成していません。",
    "publish_now": "今すぐ公開",
    "request_body": "サイトに公開できるのはオーナーかマネージャーだけです。変更内容を確認して依頼してください。",
    "request_button": "マネージャーに送る",
    "request_failed": "送信できませんでした。もう一度お試しください。",
    "request_heading": "マネージャーに公開を依頼",
    "request_manual": "マネージャーに「サイトのデザイン」を開いて公開を押すよう伝えてください。",
    "request_sent": "送信しました — マネージャーのやることリストに表示されます。",
    "request_title": "サイトのデザイン「{{theme}}」を公開してください",
    "schedule_button": "予約する",
    "time_label": "日時（日本時間）",
    "time_past": "未来の日時を選んでください。",
    "title": "変更を公開",
    "warnings_one": "確認したほうがよいこと {{count}} 件（公開はできます）",
    "warnings_other": "確認したほうがよいこと {{count}} 件（公開はできます）",
    "when": "いつ"
  },
  "publish_result": {
    "cancel_schedule": "取り消す",
    "done": "公開しました（バージョン {{version}}）— 数秒でサイトに反映されます。",
    "not_updated": "サイトがまだ更新されていない可能性があります。",
    "schedule_cancel_failed": "取り消せませんでした。もう一度お試しください。",
    "schedule_cancelled": "予約公開を取り消しました。",
    "schedule_failed": "予約公開ができませんでした。もう一度公開してください。",
    "scheduled": "予約しました — {{when}}（日本時間）に公開されます。",
    "scheduled_bar": "{{when}}（日本時間）に公開予定",
    "unknown": "公開しました。サイトを開いて確認してください。",
    "updated": "サイトが更新されました。",
    "updating": "サイトを更新しています…",
    "view_site": "サイトを見る"
  },
  "versions": {
    "back_to_editor": "エディタに戻る",
    "compare": "下書きとの違い",
    "compare_intro": "今の下書きとこのバージョンの違い：",
    "empty": "まだ公開していません。",
    "intro": "デザインをサイトに公開した記録",
    "load_failed": "履歴を読み込めませんでした。もう一度お試しください。",
    "restore_draft": "下書きにも戻す",
    "restore_draft_hint": "今の下書きがこのバージョンに置き換わります。オフのままなら下書きはそのままです。",
    "rollback": "このバージョンに戻す",
    "rollback_body": "数秒でお客様にこのバージョンが表示されます。",
    "rollback_confirm": "戻す",
    "rollback_failed": "戻せませんでした。もう一度お試しください。",
    "rollback_title": "バージョン {{version}} に戻しますか？",
    "rolled_back": "サイトはバージョン {{version}} に戻りました。",
    "title": "公開履歴",
    "version": "バージョン {{version}}",
    "reason": {
      "publish": "公開",
      "rollback": "戻す",
      "scheduled": "予約公開",
      "seed": "初期設定",
      "import": "インポート"
    }
  },
  "icons": {
    "truck": "配送",
    "package": "荷物",
    "box": "箱",
    "shield": "保護",
    "badge-check": "確認済み",
    "star": "星",
    "sparkles": "新着",
    "heart": "お気に入り",
    "gift": "ギフト",
    "credit-card": "支払い",
    "rotate-ccw": "返品",
    "map-pin": "場所",
    "store": "店舗",
    "shopping-bag": "バッグ",
    "message-circle": "メッセージ"
  },
  "tour": {
    "open": "エディタの使い方（かんたんガイド）",
    "progress": "{{total}} 中 {{step}}",
    "close": "ガイドを閉じる",
    "skip": "あとで",
    "back": "戻る",
    "next": "次へ",
    "done": "わかった",
    "select": {
      "title": "1. 変えたい所を選ぶ",
      "body": "左の一覧から部品を選ぶか、真ん中のページを直接クリックします（例：上の大きなバナー）。"
    },
    "edit": {
      "title": "2. 画像や文字を変える",
      "body": "右側で選んだ部品を変更します。「画像を変更」を押すか、新しい文字を入力します。下書きとして自動で保存されます。"
    },
    "mobile": {
      "title": "3. スマホで確認する",
      "body": "スマホのボタンを押すと、スマホでの見え方を確認できます。お客様の多くはスマホで買い物をします。"
    },
    "publish": {
      "title": "4. サイトに公開する",
      "body": "よければ「公開」を押します。数秒でお客様に表示されます。",
      "body_request": "よければ「管理者に公開を依頼」を押します。管理者がサイトに公開します。"
    },
    "undo": {
      "title": "5. いつでも元に戻せます",
      "body": "間違えたら「元に戻す」（⌘Z / Ctrl+Z）。「履歴」から2クリックで以前のサイトに戻せます。"
    }
  },
  "live": {
    "bar": "編集中に{{name}}さんが「{{what}}」を変更しました。",
    "someone": "ほかの人",
    "bar_hint": "相手の内容を読み込むと、この部分でまだ保存していない変更はなくなります。",
    "load": "相手の内容を読み込む",
    "compare": "比べる",
    "followed": "「{{what}}」に{{name}}さんの変更を反映しました。",
    "diff_title": "「{{what}}」の違い",
    "diff_intro": "この画面のあなたの内容と、{{name}}さんが保存した内容を比べています。",
    "diff_only_theirs": "相手の内容だけにある: {{name}}",
    "diff_only_mine": "あなたの内容だけにある: {{name}}",
    "diff_changed": "{{name}}が違います: {{fields}}",
    "diff_blocks": "中の項目",
    "diff_visibility": "表示 / 非表示",
    "diff_order": "パーツの並び順が違います。",
    "diff_settings": "違う設定: {{fields}}",
    "diff_same": "違いはありません。どちらも同じ内容です。",
    "diff_loading": "相手の内容を読み込み中…",
    "diff_failed": "相手の内容を読み込めませんでした。もう一度お試しください。",
    "use_theirs": "相手の内容を使う",
    "keep_mine": "自分の内容で保存",
    "close": "閉じる"
  }
}
